// extracted by mini-css-extract-plugin
module.exports = {"varAdditional04Extra100":"var(--tkww-union-color-additional-04extra-100, #FFF5ED)","varSpBase":"1rem","varSpUp1":"1.25rem","legalCopyContainer":"legalCopyContainer--24467"};